import { render, staticRenderFns } from "./ApprovalLeave.vue?vue&type=template&id=5175421d&"
import script from "./ApprovalLeave.vue?vue&type=script&lang=js&"
export * from "./ApprovalLeave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports